import type { QueryClient } from "@tanstack/react-query";
import { StudentsApi, type SearchQueryRequest } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import { toStudentSearchBody } from "@/features/students/shared/studentFilters";

export async function prefetchStudentsScrollGet(
  queryClient: QueryClient,
  page: number = 1,
  pageSize: number = 30,
  lastSelectedId?: number | null,
  active?: boolean,
  accessToken?: string,
  searchQueryRequest: SearchQueryRequest | null = null,
) {
  if (!accessToken) {
    return queryClient;
  }

  const searchBody = toStudentSearchBody(searchQueryRequest);
  const useSearch = searchBody != null;
  const service = createAuthenticatedApi(StudentsApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [
      QueryKeys.Students,
      useSearch ? "search" : "scroll",
      page,
      pageSize,
      lastSelectedId,
      active,
      searchQueryRequest,
    ],
    queryFn: () => {
      const scrollParams = {
        page,
        pageSize,
        lastSelectedId: lastSelectedId ?? undefined,
        active,
      };

      if (useSearch) {
        return service.apiStudentsSearchPost({
          ...scrollParams,
          searchQueryRequest: searchBody,
        });
      }

      return service.apiStudentsScrollGet(scrollParams);
    },
  });

  return queryClient;
}
